module.exports = __webpack_public_path__ + "img/mywah_cooler_front_x1.dadc6510.png";